<template>
    <div class="container">

        <div class="row">
            <div class="col-md-12 mt-2 mb-3">
                <h1>Domov</h1>
            </div>
        </div>

    </div>
</template>

<script>
    import firebase from 'firebase'
    import {db} from '../main'
    import {VueGoodTable} from 'vue-good-table'
    import 'vue-good-table/dist/vue-good-table.css'
    import vSelect from 'vue-select'
    import 'vue-select/dist/vue-select.css'

    export default {
        name: 'Home',
        components: {
            VueGoodTable,
            vSelect,
        },
        data () {
            return {

            }
        },
        mounted () {
            const _this = this;
        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Home.vue